// Montenegrin translations (Crnogorski)
export const me = {
  // Navigation
  nav: {
    home: "Početna",
    rooms: "Sobe",
    amenities: "Sadržaji",
    gallery: "Galerija",
    virtualTour: "Virtuelna Tura",
    location: "Lokacija",
    contact: "Kontakt",
    bookNow: "Rezerviši"
  },
  
  // Hero
  hero: {
    tagline: "Porodični hotel sa 3 zvjezdice, 2 minuta od Velike plaže, Ulcinj",
    description: "Jednostavan porodični hotel sa 3 zvjezdice na Kepi i Gjeranave, oko 2 minuta hoda od pijeska na početku Velike plaže, ulcinjske plaže duge 12 km. Doručak, večera, bazen, Wi-Fi i garaža su uključeni. Sobe su čiste i funkcionalne, bez luksuza — većina ima balkon, mnoge gledaju na more.",
    exploreRooms: "Pogledaj Sobe",
    viewGallery: "Pogledaj Galeriju",
    veryGood: "Vrlo dobro",
    reviews: "recenzija",
    starHotel: "Hotel sa 3 zvjezdice",
    bookDirect: "Rezerviši direktno i uštedi",
    bestPrice: "Jeftinije nego na Booking.com za istu sobu",
    freeCancellation: "Besplatno otkazivanje na fleksibilnim tarifama",
    noBookingFees: "Bez naknada za rezervaciju",
    checkAvailability: "Provjeri Dostupnost →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Provjeri Dostupnost i Rezerviši",
    checkIn: "Dolazak",
    checkOut: "Odlazak",
    adults: "Odrasli",
    children: "Djeca",
    adult: "Odrasla osoba",
    child: "Dijete",
    searchAvailability: "Pretraži Dostupnost",
    secureBooking: "Sigurna rezervacija • Garantovana najbolja cijena • Besplatno otkazivanje za većinu soba",
    freeCancellation: "Besplatno otkazivanje za većinu rezervacija"
  },
  
  // Rooms
  rooms: {
    title: "Jednostavne, čiste sobe uz plažu",
    subtitle: "Smještaj",
    description: "13 tipova soba, od male jednokrevetne do apartmana sa dvije spavaće sobe. Svaka soba ima klimu, kupatilo i besplatan Wi-Fi; većina ima balkon. Namještaj je funkcionalan, ne dizajnerski.",
    viewDetails: "Pogledaj Detalje",
    bookNow: "Rezerviši",
    perNight: "/noć",
    guests: "Gostiju",
    backToRooms: "Nazad na Sve Sobe",
    roomAmenities: "Sadržaji Sobe",
    standardFeatures: "Standardne Karakteristike"
  },
  
  // Room Names (Montenegrin)
  roomNames: {
    room1: "Dvokrevetna soba sa pogledom na more i balkonom",
    room2: "Dvokrevetna soba pored bazena",
    room3: "Ekonomska dvokrevetna soba sa balkonom (bez pogleda)",
    room4: "Soba sa dva odvojena kreveta i zajedničkom terasom sa pogledom na more",
    room5: "Executive trokrevetna soba sa pogledom na more i balkonom",
    room6: "Dvokrevetna soba sa pomoćnim krevetom - pogled na more i balkon",
    room7: "Dvosobni porodični apartman",
    room8: "Porodična soba sa zajedničkom terasom",
    room9: "Porodična soba sa terasom",
    room10: "Mala jednokrevetna soba",
    room11: "Trokrevetna soba sa balkonom",
    room12: "Porodična soba sa pogledom na planine",
    room13: "Jednosobni apartman"
  },
  
  // Amenities
  amenities: {
    title: "Sadržaji Hotela",
    subtitle: "Što Nudimo",
    beachfront: "Lokacija na Plaži",
    beachfrontDesc: "Direktan pristup Velikoj plaži",
    childrenPool: "Bazen za Djecu",
    childrenPoolDesc: "Siguran bazen za porodice",
    restaurant: "Restoran i Kafe",
    restaurantDesc: "Balkanska kuhinja · bez alkohola",
    wifi: "Besplatan WiFi",
    wifiDesc: "Brzi internet",
    parking: "Besplatan Parking",
    parkingDesc: "Siguran parking",
    shuttle: "Aerodromski Transfer",
    shuttleDesc: "€80 sa aerodroma Podgorica i Tivat (na zahtjev)",
    frontDesk: "24-satna Recepcija",
    frontDeskDesc: "24/7 usluga",
    elevator: "Lift",
    elevatorDesc: "Svi spratovi"
  },
  
  // Gallery
  gallery: {
    intro: "Otkrijte ljepotu Hotela La Rosa Negra i šarm Ulcinja.",
    title: "Foto Galerija",
    subtitle: "Istražite Naš Hotel",
    all: "Sve",
    rooms: "Sobe",
    pool: "Bazen",
    beach: "Plaža",
    restaurant: "Restoran",
    exterior: "Eksterijer"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "360° Virtuelna Tura",
    subtitle: "Doživite Naš Hotel",
    description: "Prošetajte virtuelno kroz naš prekrasan hotel"
  },
  
  // Location
  location: {
    title: "Naša Lokacija",
    subtitle: "Pronađite Nas",
    address: "Adresa",
    nearbyAttractions: "Obližnje Atrakcije"
  },
  
  // Contact
  contact: {
    title: "Kontaktirajte Nas",
    subtitle: "Javite Nam Se",
    name: "Ime",
    email: "Email",
    message: "Poruka",
    send: "Pošalji Poruku",
    phone: "Telefon",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Odgovori na najčešća pitanja o Hotelu La Rosa Negra.",
    title: "Često Postavljana Pitanja",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Brzi Linkovi",
    contactInfo: "Kontakt Informacije",
    followUs: "Pratite Nas",
    rights: "Sva prava zadržana",
    starHotel: "Hotel sa zvjezdicama",
    description: "Doživite savršen spoj mediteranskog šarma i modernog komfora direktno na Velikoj plaži, Ulcinj, Crna Gora.",
    rooms: "Sobe i apartmani",
    amenities: "Sadržaji",
    gallery: "Galerija",
    location: "Lokacija",
    reviews: "Recenzije",
    legal: "Pravne informacije",
    privacy: "Politika privatnosti",
    terms: "Uslovi korišćenja",
    cookies: "Politika kolačića",
    cancellation: "Politika otkazivanja"
  },

  // Smart language-hint toast
  langHint: {
    message: "Ova stranica je dostupna i na crnogorskom jeziku",
    switch: "Promijeni",
    dismiss: "Odbaci"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Direktna rezervacija",
    heading: "Zašto rezervisati direktno?",
    lead: "Ovdje je jeftinije nego na Booking.com i dogovarate se direktno sa nama — evo tačno šta dobijate",
    b1t: "Niža cijena nego na Booking.com",
    b1d: "Naša direktna cijena je 10% niža od naše cijene na Booking.com za istu sobu i datume. Našli ste jeftinije tamo? Pošaljite link i izjednačićemo.",
    b2t: "10% popust",
    b2d: "Tih 10% je već u cijeni koju vidite ovdje — bez koda, bez dodatnih naknada.",
    b3t: "Jasni uslovi otkazivanja",
    b3d: "Fleksibilne tarife se otkazuju besplatno do datuma prikazanog pri rezervaciji; nepovratne tarife su jasno označene prije plaćanja.",
    b4t: "Odgovara čovjek",
    b4d: "WhatsApp, telefon ili e-mail — recepcija obično odgovara u roku od nekoliko sati, 08:00–23:00.",
    cta: "Rezerviši direktno i uštedi"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Sadržaji",
    heading: "Šta hotel ima",
    lead: "Sadržaji koji zaista postoje — ni više, ni manje.",
    ctaTitle: "Pitanja prije rezervacije?",
    ctaLead: "Pitajte nas bilo šta o sobama, plaži ili dolasku — odgovaramo iskreno.",
    ctaButton: "Kontaktirajte konsijerža"
  },

  // Contact section
  contactForm: {
    title: "Pišite pravom timu",
    subtitle: "Izaberite odjeljenje i odgovorićemo vam u roku od jednog radnog dana.",
    dep_sales: "Prodaja", hint_sales: "Grupne rezervacije, događaji, korporativne cijene, agencije",
    dep_jobs: "Prijava za posao", hint_jobs: "Pošaljite nam CV — recepcija, domaćinstvo, F&B, održavanje",
    dep_pr: "Odnosi s javnošću", hint_pr: "Mediji, štampa, partnerstva i saradnje",
    name: "Vaše ime", email: "Email adresa", phone: "Telefon (opciono)", subject: "Naslov", position: "Pozicija za koju se prijavljujete",
    message: "Vaša poruka", messageJobs: "Recite nam nešto o sebi, iskustvu i dostupnosti",
    attachCv: "Priložite CV (PDF ili Word, max 5 MB)", send: "Pošalji poruku",
    successTitle: "Poruka poslata!", successBody: "Hvala — vaša poruka je stigla do našeg tima:", sendAnother: "Pošalji još jednu poruku",
    error: "Slanje nije uspjelo. Pokušajte ponovo.", privacy: "Vaše podatke koristimo samo za odgovor na upit."
  },
  contactSection: {
    eyebrow: "Kontaktirajte nas",
    heading: "Javite nam se",
    lead: "Imate pitanja? Tu smo da pomognemo. Javite nam se u bilo koje doba.",
    addressLabel: "Adresa",
    phoneLabel: "Telefon",
    emailLabel: "Email",
    receptionLabel: "Radno vrijeme recepcije",
    reception247: "24/7 - Uvijek smo tu za vas",
    whatsappBtn: "Chat na WhatsApp-u",
    emailBtn: "Pošalji email",
    bookDirectTitle: "Rezerviši direktno i uštedi",
    bookDirectDesc: "Ostvarite 10% popusta kada rezervišete preko našeg sajta",
    checkAvailability: "Provjeri dostupnost",
    whatsappPrefill: "Pozdrav, želio bih se raspitati o Hotelu La Rosa Negra"
  },

  // Reviews section
  reviews: {
    eyebrow: "Recenzije gostiju",
    heading: "Šta kažu gosti — bez izmjena",
    lead: "Recenzije su preuzete sa Booking.com-a kako su napisane, uključujući kritike. Procijenite sami.",
    veryGood: "Vrlo dobro",
    reviewsCount: "recenzija",
    starHotel: "Hotel sa 3 zvjezdice",
    readMoreOn: "Pročitajte više recenzija na",
    translatedFrom: "Prevedeno sa: {lang}",
    showOriginal: "Prikaži original",
    showTranslation: "Prikaži prevod"
  },

  // Handoff
  handoff: {
    prompt: "Želite razgovarati sa našim timom?",
    button: "Nastavi na WhatsApp-u",
    prefix: "Pozdrav Hotel La Rosa Negra! Razgovarao/la sam sa vašim virtuelnim asistentom i želio/la bih nastaviti sa osobom."
  },

  // Common
  common: {
    learnMore: "Saznaj Više",
    seeAll: "Pogledaj Sve",
    close: "Zatvori",
    loading: "Učitavanje..."
  }
};
